/**
 * Turning a clicked route into navlog rows: for every pair of consecutive
 * waypoints, the true course, the distance and the magnetic variation that
 * belongs in the leg's VAR field.
 *
 * This is the whole contract between the map and the form — everything after
 * it (WCA, MH, GS, times) is `calc/route.ts`.
 */
import { distanceNm, initialBearingDeg, midpoint } from './geodesy.js';
import { magneticDeclination } from './wmm.js';
/**
 * One leg from `a` to `b`. The variation is taken at the leg's midpoint, which
 * is what a pilot reads off the chart in the middle of the leg rather than at
 * either end.
 */
export function legFromWaypoints(a, b, date) {
    return {
        tc: initialBearingDeg(a, b),
        distNm: distanceNm(a, b),
        varDeg: magneticDeclination(midpoint(a, b), date),
    };
}
/** Every leg of a route. `n` waypoints give `n - 1` legs; fewer than two give none. */
export function routeLegs(waypoints, date) {
    const out = [];
    for (let i = 1; i < waypoints.length; i++) {
        const from = waypoints[i - 1];
        const to = waypoints[i];
        if (from && to)
            out.push(legFromWaypoints(from, to, date));
    }
    return out;
}
//# sourceMappingURL=leg.js.map